import React from 'react';
import LiveIconAnimatedImg from '@tradera/blueprint/theme/icons-animated/live.svg';
import LiveIcon from '@tradera/blueprint/theme/icons2/live.svg?jsx';

const LiveShoppingIcon = ({ animated, className }) => {
    if (animated) {
        return (
            <img src={LiveIconAnimatedImg} className={`icon ${className}`} />
        );
    } else {
        return <LiveIcon className={`icon ${className}`} />;
    }
};

LiveShoppingIcon.propTypes = {};

export { LiveShoppingIcon };
